import { React } from "react";
import Feature from "../../components/feature/Feature";
import "./whatis.css";

const features = [
  {
    title: "Chatbots",
    text: "We so opinion friends me message as delight. Whole front do of plate heard oh ought.",
    type: "feature-vertical",
  },
  {
    title: "Knowledgebase",
    text: "At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b",
    type: "feature-vertical",
  },
  {
    title: "Education",
    text: "At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b",
    type: "feature-vertical",
  },
];

const Whatis = () => {
  return (
    <div className="gpt3__whatis-container" id="wgpt3">
      <div className="gpt3__whatis-internalContainer">
        <div className="gpt3__whatis-row">
          <h2 className="gpt3__whatis-row_title">What is GPT-3</h2>
          <p className="gpt3__whatis-row_p">
            We so opinion friends me message as delight. Whole front do of plate
            heard oh ought. His defective nor convinced residence own.
            Connection has put impossible own apartments boisterous. At jointure
            ladyship an insisted so humanity he. Friendly bachelor entrance to
            on by.
          </p>
        </div>
        <div className="gpt3__whatis-row padding6">
          <h3 className="gpt3__whatis-row_titleBackground">
            The possibilities are beyond your imagination
          </h3>
          <div className="gpt3__whatis-row_linkContainer">
            <a href="#" className="gpt3__whatis-row_a">
              Explore The Library
            </a>
          </div>
        </div>
        <div className="gpt3__whatis-row">
          {features.map((feature, id) => {
            return (
              <Feature
                key={id}
                title={feature.title}
                text={feature.text}
                type={feature.type}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Whatis;
